import React, { lazy, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { themeChange } from 'theme-change';
import checkAuth from './app/auth';
import initializeApp from './app/init';
import { useDispatch, useSelector } from 'react-redux';
import { setclass } from './features/classes/classSlice';
import useFetch from './hooks/useFetch';
import { setStudent } from './features/Showstudent/studentSlice';
import { setFees } from './features/fees/feesSlice';
import { setScholar } from './features/scholarship/scholarSlice';
import { setstaff } from './features/Staffcategory/staffSlice';
import { setAddstaff } from './features/AddStaffs/StaffsSlice';

// Importing pages
const Layout = lazy(() => import('./containers/Layout'));
const Login = lazy(() => import('./pages/Login'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const Register = lazy(() => import('./pages/Register'));
const Documentation = lazy(() => import('./pages/Documentation'));
const PrintVoucher = lazy(() => import('./pages/PrintVoucher'));

// Initializing different libraries
initializeApp();

// Check for login and initialize axios
const token = checkAuth();

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const dispatch = useDispatch();

  const { data: gradeData } = useFetch("/getallgrade.php");
  const { data: getallstudent } = useFetch("/getallstudent.php");
  const { data: getFees } = useFetch("/getallfee.php");
  const { data: getallScholar } = useFetch("/getallscholarship.php");
  const { data: getallstaff } = useFetch("/getstaffcategory.php");
  const { data: getallStaffs } = useFetch("/getallstaff.php");
  const { vouchersToPrint } = useSelector(state => state.voucher);

  useEffect(() => {
    themeChange(false); // Daisy UI themes initialization
  }, []);

  useEffect(() => {
    if (gradeData) dispatch(setclass(gradeData));
    if (getallstudent) dispatch(setStudent(getallstudent));
    if (getFees) dispatch(setFees(getFees));
    if (getallScholar) dispatch(setScholar(getallScholar));
    if (getallstaff) dispatch(setstaff(getallstaff));
    if (getallStaffs) dispatch(setAddstaff(getallStaffs));
  }, [dispatch, gradeData, getallstudent, getFees, getallScholar, getallstaff, getallStaffs]);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/documentation" element={<Documentation />} />
        {token && vouchersToPrint.length > 0 && <Route path="/printvoucher" element={<PrintVoucher />} />}
        <Route path="/app/*" element={<Layout />} />
        <Route path="*" element={<Navigate to={token ? "/app/dashboard" : "/login"} replace />} />
      </Routes>
    </Router>
  );
}

export default App;
